import type { LoginHistoryForm } from "./login-history-form";
import type { LoginHistoryHandler } from "./login-history-handler";

export class LoginHistoryListener {
    private readonly form: LoginHistoryForm;
    private readonly handler: LoginHistoryHandler;

    public constructor(form: LoginHistoryForm, handler: LoginHistoryHandler) {
        this.form = form;
        this.handler = handler;
    }

    public register(): void {
        this.form.getTriggerButtons().forEach((button) => {
            button.addEventListener("click", () => void this.handler.open(button));
        });

        const overlay = this.form.getOverlay();
        if (overlay instanceof HTMLElement) {
            overlay.addEventListener("click", () => this.handler.close());
        }

        this.form.getCloseButtons().forEach((button) => {
            button.addEventListener("click", () => this.handler.close());
        });
    }
}
